import { render, staticRenderFns } from "./FilterSetting.vue?vue&type=template&id=c0a6670a&scoped=true&"
import script from "./FilterSetting.vue?vue&type=script&lang=js&"
export * from "./FilterSetting.vue?vue&type=script&lang=js&"
import style0 from "./FilterSetting.vue?vue&type=style&index=0&id=c0a6670a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a6670a",
  null
  
)

export default component.exports